import { initSentry } from './utils/sentry';
import React from 'react';
import { createRoot } from 'react-dom/client';
import './lib/i18n';  // Import i18n configuration
import App from './App';


/* Tailwind CSS */
import './theme/main.css';

/* App CSS */
import './theme/app.css'

// Initialize Sentry as early as possible - before any other code runs
try {
  if (process.env.NODE_ENV !== 'development') {
    initSentry();
  }
  else {
    console.log('Sentry not initialized in development mode');
  }
} catch (error) {
  console.error('Error initializing Sentry:', error);
}

// Add a global error handler for uncaught errors
window.addEventListener('error', (event) => {
  console.error('Global error caught:', event.error);
});

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
